import { BAC_MODE_NAME, getMode } from './utils';

// The bac mode draws Masks, but outside any task: there is no label pass to save.
export const READONLY_MODES = ['readonly', 'feedback', 'preview', 'basic-viewer', BAC_MODE_NAME];

export function isReadonly() {
  const mode = getMode();
  return READONLY_MODES.includes(mode);
}
